import fetch from './../../fetch';

/**
 * 相关性分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const correlationAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('survey/common/analysis/correlationAnalysis', Object.assign(defaultsParams, keywords))
}

/**
 * 回归分析
 * @param {object} [keywords]
 * @return {promise}
 */
 const regressionAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('survey/common//analysis/regressionAnalysis', Object.assign(defaultsParams, keywords))
}


/**
 * 正态数据检验分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const normalTest = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('survey/common/analysis/normalTest', Object.assign(defaultsParams, keywords))
}

/**
 * 正态数据检验分析
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const plotAnalysis = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('survey/common/analysis/plotAnalysis', Object.assign(defaultsParams, keywords))
}


/**
 * 回归数据分布
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const plotRegression = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.post('survey/common/analysis/plotRegression', Object.assign(defaultsParams, keywords))
}




const checkTargetIds = (keywords) => {
    return fetch.post('survey/common/analysis/checkTargetIdsType', keywords)
}

/**
 * 高校相关性数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportCorrelation = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.download('survey/common/analysis/exportCorrelation', Object.assign(defaultsParams, keywords), "高校相关性数据导出.xls")
}

/**
 * 问卷回归数据导出
 * @method multiple
 * @param {object} [keywords]
 * @return {promise}
 */
 const exportRegression = (keywords) => {
    const session = JSON.parse(sessionStorage.session || '{"account": {}}')
    const account = session.account;

    const defaultsParams = {
        bgTermId: account.termId,
        endTermId: account.termId
    };
    return fetch.download('survey/common/analysis/exportRegression', Object.assign(defaultsParams, keywords), "高校回归分析数据分析.xls")
}

const checkTargetIdsTypeForRegression = (keywords) => {
    return fetch.post('survey/common/analysis/checkTargetIdsTypeForRegression', keywords)
}

export default {
    correlationAnalysis ,
    checkTargetIds,
    normalTest,
    plotAnalysis,
    exportCorrelation,
    regressionAnalysis,
    plotRegression,
    exportRegression,
    checkTargetIdsTypeForRegression
}